import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input } from 'grab-ui';

const DummyFieldError = ({ id, fieldOptions, form }) => {
  const { getFieldDecorator } = form;

  return (
    <Form.Item>
      {getFieldDecorator(id, fieldOptions)(<Input type={'hidden'} />)}
    </Form.Item>
  );
};

DummyFieldError.propTypes = {
  id: PropTypes.string.isRequired,
  fieldOptions: PropTypes.shape({}),
  form: PropTypes.shape({}).isRequired,
};

DummyFieldError.defaultProps = {
  fieldOptions: {},
};

export default DummyFieldError;
